var map = {
	"./3d Speks.png": 7492,
	"./Angry.png": 1706,
	"./Aviators.png": 1507,
	"./Burning Flames.png": 8570,
	"./Eye Shadow.png": 8477,
	"./Goofy.png": 7072,
	"./Hypno.png": 5536,
	"./Icy Standard.png": 613,
	"./Purple Specs.png": 1088,
	"./Red Glasses.png": 4727,
	"./Rose Gold Standard.png": 4345,
	"./Standard.png": 6241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1116;